import { InstructorTableCellType } from '@/enums/InstructorTableCellType';
export default class InstructorTableAvailableCell {
    cellType = InstructorTableCellType.AVAILABLE;
    hour;
    length = 1;
    row;
    constructor(row) {
        this.row = row;
    }
    toSaveObject() {
        const { row, ...saveObject } = this;
        return saveObject;
    }
}
